import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import RefreshIcon from "@mui/icons-material/Refresh";

import { useConversation } from "@lobees/chat-core";

import { getData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

const ConversationLeftPanel = ({ allContacts, setAllContacts, fullWidth = false }) => {
  const { selectConversation, conversation } = useConversation();

  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const getAllContactList = async () => {
    try {
      setIsLoading(true);
      const requestUrl = url.API_BASE_URL + url.API_GET_ALL_CONTACTS;
      const response = await getData(requestUrl);
      setIsLoading(false);

      if (response.status) {
        setAllContacts(response.data);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error.message);
    }
  };

  useEffect(() => {
    getAllContactList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filteredContacts = allContacts.filter((contact) =>
    contact.contactname.toLowerCase().includes(searchValue.toLowerCase().trim())
  );

  return (
    <Box
      sx={{
        width: fullWidth ? "100%" : 320,
        minWidth: fullWidth ? "100%" : 320,
        borderRight: "1px solid",
        borderColor: "divider",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ p: 2, display: "flex", alignItems: "center", gap: 1 }}>
        <TextField
          size="small"
          fullWidth
          placeholder="Search contacts"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <IconButton onClick={getAllContactList} title="Refresh">
          <RefreshIcon fontSize="small" />
        </IconButton>
      </Box>

      <Box sx={{ flex: 1, width: "100%", overflowY: "auto" }}>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress size={24} />
          </Box>
        ) : filteredContacts.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
            No contacts found.
          </Typography>
        ) : (
          <List disablePadding>
            {filteredContacts.map((contact, index) => {
              const isActive = conversation?.roomId === contact._id;

              return (
                <ListItemButton
                  key={contact._id ?? index}
                  selected={isActive}
                  onClick={() =>
                    selectConversation({
                      id: contact.userid,
                      name: contact.contactname,
                      logo: contact.contactimage,
                      email: contact.contactemail,
                      kind: "contact",
                      roomId: contact._id,
                      phone: contact.contactphone,
                      address: contact.location,
                      company: contact.contactcompany,
                    })
                  }
                >
                  <ListItemAvatar>
                    <Avatar
                      src={
                        contact.contactimage
                          ? url.SERVER_URL + contact.contactimage
                          : undefined
                      }
                    >
                      {contact.contactname?.charAt(0)}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={contact.contactname}
                    secondary={
                      contact.lastmessagetext
                        ? contact.lastmessagetext.slice(0, 30)
                        : contact.contactemail
                    }
                    primaryTypographyProps={{ noWrap: true }}
                    secondaryTypographyProps={{ noWrap: true }}
                  />
                </ListItemButton>
              );
            })}
          </List>
        )}
      </Box>
    </Box>
  );
};

export default ConversationLeftPanel;
